import { defineMessages } from 'react-intl';

const messages = defineMessages({
  recommended: {
    id: 'collegeevents.filters.recommended',
    defaultMessage: 'Show me:',
  },
  clearfilters: {
    id: 'collegeevents.filters.clearfilters',
    defaultMessage: 'Clear all filters',
  },
  showfilters: {
    id: 'collegeevents.filters.showfilters',
    defaultMessage: 'Filters',
  },
  virtualevents: {
    id: 'collegeevents.filters.virtual.events',
    defaultMessage: 'Virtual events',
  },
  recommendedevents: {
    id: 'collegeevents.filters.recommended.recommendedevents',
    defaultMessage: 'Recommended events',
  },
  within: {
    id: 'collegeevents.filter.within',
    defaultMessage: 'Event located within',
  },
  displaymiles: {
    id: 'collegeevents.filter.displaymiles',
    defaultMessage: 'any distance',
  },
  miles: {
    id: 'collegeevents.filter.miles',
    defaultMessage: '{value} miles',
  },
  outsideof: {
    id: 'collegeevents.filter.outsideof',
    defaultMessage: 'of ZIP code',
  },
  postalcode: {
    id: 'collegeevents.filter.postalcode',
    defaultMessage: 'ZIP code',
  },
  collegesize: {
    id: 'collegeevents.filter.collegesize',
    defaultMessage: 'College size:',
  },
  size: {
    id: 'collegeevents.filter.size',
    defaultMessage: 'Any college size',
  },
  collegelocated: {
    id: 'collegeevents.filter.collegelocated',
    defaultMessage: 'College located in:',
  },
  location: {
    id: 'collegeevents.filter.location',
    defaultMessage: 'US state or Canadian province',
  },
  collegemajors: {
    id: 'collegeevents.filter.collegemajors',
    defaultMessage: 'College with certain majors (up to 3):',
  },
  majors: {
    id: 'collegeevents.filter.majors',
    defaultMessage: 'Search for majors',
  },
  hostedby: {
    id: 'collegeevents.filter.hostedby',
    defaultMessage: 'Hosted by:',
  },
  collegenamefilter: {
    id: 'collegeevents.filter.collegenamefilter',
    defaultMessage: 'Type college name here',
  },
  datesearch: {
    id: 'collegeevents.filter.dateseach',
    defaultMessage: 'Date range:',
  },
  done: {
    id: 'collegeevents.filter.done',
    defaultMessage: 'DONE',
  },
  close: {
    id: 'collegeevents.filter.close',
    defaultMessage: 'Close',
  },
  reset: {
    id: 'collegeevents.filter.reset',
    defaultMessage: 'RESET',
  },
});

export default messages;
